import React, { useState, useEffect, useRef } from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import { debounce } from "lodash";
import { useTranslation } from "react-i18next";
import {
  Breadcrumb,
  Space,
  Select,
  DatePicker,
  Table,
  Input,
  Col,
  Form,
  Row,
  Popconfirm,
  Tooltip,
  Button,
  Dropdown,
  Menu,
  Checkbox,
} from "antd";
import ButtonField from "../../common/htmlComponents/ButtonField";
import ExelDownload from "../../image/exeldownload.svg";
import RefreshIcon from "../../image/refreshIcon.svg";
import SearchIcon from "../../image/SearchIcon.svg";
import { ReactComponent as Archiveicon } from "../../image/Archiveicon.svg";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import { getRequest, postRequest } from "../../axios";
import moment from "moment";
import DealDone from "../../image/DealDone.svg";
import Proposal from "../../image/Proposal.svg";
import OpenIcon from "../../image/OpenIcon.svg";
import Callcenter from "../../image/Callcenter.svg";
import OrderApprove from "../../image/OrderApprove.svg";
import PendingActions from "../../image/PendingActions.svg";
import rejectedIcon from "../../image/rejectedIcon.svg";
import pendingIcon from "../../image/work_history.svg";
import TotalCount from "../../image/TotalCount.svg";
import OrderIssuedApprove from "../../image/OrderIssuedApprove.svg";
import OrderYetAccepted from "../../image/OrderYetAccepted.svg";
import { ReactComponent as Archive } from "../../image/Archive.svg";
import {
  DownloadOutlined,
  FilterOutlined,
  UndoOutlined,
} from "@ant-design/icons";
import { authUserData } from "../../utils/Helper";
import { ReactComponent as Editicon } from "../../image/Editicon.svg";
import "jspdf-autotable";
import jsPDF from "jspdf";
import { font } from "../../common/font";
import { ReactComponent as ColumnList } from "../../image/ColumnList.svg";

const VendorPurchaseOrderSummary = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const vendorId = authUserData()?.vendor ? authUserData()?.vendor : null;
  const [reload, setReload] = useState(false);
  const { rfqId } = useParams();
  const { Search } = Input;
  const [totalCount, settotalCount] = useState(0);
  const [rfqHistory, setRFQHistory] = useState([]);
  const [rfqStatus, setRfqStatus] = useState("");
  const [selectedRow, setSelectedRow] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const formRef = useRef();
  const [selectedCard, setSelectedCard] = useState(null);
  // const [categoryTree, setCategoryTree] = useState([]);
  const [categoryTreeFilter, setCategoryTreeFilter] = useState("");
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const { id } = useParams();
  // const rfqId = id;
  const [categoryId, setCategoryId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [clickedFilterButton, setClickedFilterButton] = useState(false);
  const [statusCounts, setStatusCounts] = useState({
    total_purchase_order: 0,
    pending_for_approval: 0,
    send_for_approval: 0,
    approve_and_issued_order: 0,
    approve_and_prepare_draft_order: 0,
    rejected: 0,
    rejected_with_reason: 0,
    order_accepted_by_vendor: 0,
    order_rejected_by_vendor: 0,
  });
  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    search: "",
  });
  useEffect(() => {
    const getRFQHistory = async () => {
      setLoading(true);
        const fields = [
          "id",
          "rfq_number",
          "po_number",
          "company_name",
          "po_created_date",
          "po_approval_date",
          "amount_without_gst",
          "amount_with_gst",
          "po_status",
          "vendor_delivery_status",
          "payment_status",
          "vendor",
        ].join(",");

        const queryParams = new URLSearchParams({
          vendor_id: vendorId,
          fields: fields,
          page: state.page,
          page_size: state.pagesize,
          ordering: state.ordering,
          ...(state.search && { search: state.search }),
          ...(state.po_created_date__gte && {
            po_created_date__gte: moment(state.po_created_date__gte, "DD-MM-YY").format("YYYY-MM-DD"),
          }),
          ...(state.po_created_date__lte && {
            po_created_date__lte: moment(state.po_created_date__lte, "DD-MM-YY").format("YYYY-MM-DD"),
          }),
          ...(state.category_id && { category_id: state.category_id }),
          ...(state.rfq_detail && { rfq_detail: state.rfq_detail }),
          ...(state.po_status && { po_status: state.po_status }),
        });

      try {
        let apiResponse = await getRequest(
          `po-order/?${queryParams.toString()}`,
          state
        );

        if (apiResponse.data.results.data) {
          setRFQHistory(apiResponse.data.results.data);
          settotalCount(apiResponse.data.count);
        } else {
          ErrorNotificationMsg(t("error_in_rfq_history"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    const getStatusCount = async () => {
      // setLoading(true);

      try {
        let apiResponse = await getRequest(
          `po-order/${vendorId}/po-status-count-vendor/`,
          state
        );
        if (apiResponse.data.success) {
          const message = apiResponse.data.data;
          setStatusCounts({
            total_purchase_order: message.total_purchase_order,
            pending_for_approval: message.pending_for_approval,
            send_for_approval: message.send_for_approval,
            approve_and_issued_order: message.approve_and_issued_order,
            approve_and_prepare_draft_order:
              message.approve_and_prepare_draft_order,
            rejected: message.rejected,
            rejected_with_reason: message.rejected_with_reason,
            order_accepted_by_vendor: message.order_accepted_by_vendor,
            order_rejected_by_vendor: message.order_rejected_by_vendor,
          });
        } else {
          ErrorNotificationMsg(t("error_in_requested_demo_list_status_count"));
        }
        // setLoading(false);
      } catch (error) {
        //setLoading(false);
      }
    };
    getRFQHistory();
    getStatusCount();
    // getCategoryTree();
  }, [reload, state, t]);
  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
  };
  const rowSelection = {
    onChange: (selectedRowKeys) => {
      setSelectedRow(selectedRowKeys);
    },
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    if (sortField === "category_tree_name" && sortOrder === "ascend") {
      sortingEnumKey = "category_tree_name";
    }
    if (sortField === "category_tree_name" && sortOrder === "descend") {
      sortingEnumKey = "-category_tree_name";
    }
    if (sortField === "pr_creator" && sortOrder === "ascend") {
      sortingEnumKey = "pr_creator";
    }
    if (sortField === "pr_creator" && sortOrder === "descend") {
      sortingEnumKey = "-pr_creator";
    }
    if (sortField === "rfq_number" && sortOrder === "ascend") {
      sortingEnumKey = "rfq_number";
    }
    if (sortField === "rfq_number" && sortOrder === "descend") {
      sortingEnumKey = "-rfq_number";
    }
    if (sortField === "pr_approval_date" && sortOrder === "ascend") {
      sortingEnumKey = "pr_approval_date";
    }
    if (sortField === "pr_approval_date" && sortOrder === "descend") {
      sortingEnumKey = "-pr_approval_date";
    }
    if (sortField === "total_amount" && sortOrder === "ascend") {
      sortingEnumKey = "total_amount";
    }
    if (sortField === "total_amount" && sortOrder === "descend") {
      sortingEnumKey = "-total_amount";
    }
    if (sortField === "rfqstatus" && sortOrder === "ascend") {
      sortingEnumKey = "rfqstatus";
    }
    if (sortField === "rfqstatus" && sortOrder === "descend") {
      sortingEnumKey = "-rfqstatus";
    }

    return sortingEnumKey;
  };
  const handleStartDateChange = (date) => {
    // Assuming 'date' is already a Moment.js object representing both date and time
    const formattedDate = moment(date).format("DD-MM-YY");
    setStartDate(formattedDate);
  };

  const handleEndDateChange = (date) => {
    const formattedDate = moment(date).format("DD-MM-YY");
    //setStartDate(date);
    setEndDate(formattedDate);
  };
  //
  const handleCategoryChange = (value) => {
    setCategoryTreeFilter(value);
  };

  // useEffect(() => {});

  // const getCategoryTree = async (data) => {
  //   await getRequest("category-tree/?no_pagination=True", data).then(
  //     (response) => {
  //       setCategoryTree(response.data.data);
  //     }
  //   );
  // };
  const handleReset = () => {
    // setPoOrderPlaced([]);
    setSelectedCard(null);
    setClickedFilterButton(false);
    setRfqStatus("");
    // setCategoryTree("");
    setEndDate("");
    setStartDate("");
    setCategoryTreeFilter("");

    setState({
      page: 1,
      ordering: "id",
      pagesize: 10,
      search: "",
    });
    formRef.current.setFieldsValue({
      po_created_date__gte: null,
      rfq_detail: null,
      category_id: null,
      po_created_date__lte: null,
    });
  };
  const handleClearFields = () => {
    setEndDate("");
    setStartDate("");
  };
  const handleClickCard = (value) => {
    setSelectedCard(value);
    setState({
      ...state,
      po_status: value,
      search: "",
      page: 1,
      // ordering: "id",
      pagesize: 10,
    });
  };
  const handleSelectRFQStatusChange = (value) => {
    //  setState({ ...state, [name]: value });
    setRfqStatus(value);
  };
  const handleExcelDownload = async () => {
    const endpoint = `po-order/${vendorId}/po-order-vendor-excel-download/`;
    const fileType = "csv";

    try {
      //setBtnloading(true);
      await getRequest(endpoint)
        .then((response) => {
          const blob = new Blob([response.data], {
            type: "text/csv",
          });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          //link.download = `purchase_requisition_${id}-${+new Date()}.${fileType}`;
          link.download = `po-order_${+new Date()}.${fileType}`;
          link.click();
          //setBtnloading(false);
        })
        .catch((error) => {
          //ErrorNotificationMsg(t(`err_${fileType}_download`));
        });
    } catch (error) {
      //setBtnloading(false);
      //ErrorNotificationMsg(error);
    }
  };

  const handlePdfDownload = async () => {
    try {
      const pdf = new jsPDF("p", "pt", "a4", true);
      pdf.addFileToVFS("WorkSans-normal.ttf", font);
      pdf.addFont("WorkSans-normal.ttf", "WorkSans", "normal");
      pdf.setFont("WorkSans");

      const pdfColumns = [
        "RFQ Number",
        "PO Number",
        "Company",
        "PO Created Date",
        "Amount Without GST",
        "Amount With GST",
        "Status",
        "Vendor Delivery Status",
      ];

      let rows = [];

      rfqHistory.forEach((item) => {
        const row = [
          item.rfq_number,
          item.po_number,
          item.company_name,
          item.po_created_date,
          "₹ " +
            item.amount_without_gst.toLocaleString("en-IN", {
              maximumFractionDigits: 0,
            }),
          "₹ " +
            item.amount_with_gst.toLocaleString("en-IN", {
              maximumFractionDigits: 0,
            }),
          item.po_status,
          item.vendor_delivery_status,
        ];

        rows.push(row);
      });

      pdf.text("Purchase Order Summary", 210, 40);

      pdf.autoTable({
        head: [pdfColumns],
        body: rows,
        startY: 65,
        theme: "grid",
        styles: {
          font: "WorkSans",
          halign: "center",
          overflow: "linebreak",
          cellPadding: 3.5,
          lineWidth: 0.5,
          lineColor: [0, 0, 0],
          textColor: [0, 0, 0],
        },
        headStyles: {
          textColor: [255, 255, 255],
          fontStyle: "normal",
          lineWidth: 0.5,
          lineColor: [0, 0, 0],
          fillColor: [9, 78, 143],
        },
        alternateRowStyles: {
          fillColor: [212, 212, 212],
          textColor: [0, 0, 0],
          lineWidth: 0.5,
          lineColor: [0, 0, 0],
        },
        rowStyles: {
          lineWidth: 0.5,
          lineColor: [0, 0, 0],
        },
        tableLineColor: [0, 0, 0],
        columnStyles: {
          4: { halign: "right" },
          5: { halign: "right" },
        },
      });

      pdf.save(`vendor_purchase_order_summary_${vendorId}_${+new Date()}`);
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };

  const handleRefresh = async () => {
    setSelectedCard(null);
    setRfqStatus("");
    // setCategoryTree("");
    setEndDate("");
    setStartDate("");
    setCategoryTreeFilter("");
    formRef.current.setFieldsValue({
      po_created_date__gte: null,
      rfq_detail: null,
      category_id: null,
      po_created_date__lte: null,
    });
    form.setFieldsValue({ search: "" });
    setState({
      ...state,
      po_status: "",
      search: "",
      page: 1,
      // ordering: "id",
      pagesize: 10,
    });
  };

  const handleArchive = async (id = "") => {
    let ids = selectedRow;
    if (ids.length === 0) {
      ids.push(id);
    }
    try {
      let apiResponse = await postRequest("float-rfq-archive/", {
        deleted: ids,
      });
      if (apiResponse.data.success) {
        SuccessNotificationMsg(t("rfq_history_archive_successfully"));
        setReload(!reload);
        setSelectedRow([]);
      } else {
        ErrorNotificationMsg(t("error_in_rfq_history_archive"));
      }
    } catch (error) {
      ErrorNotificationMsg(error);
    }
  };
  const handleApplyFilter = () => {
    setSelectedCard(null);
    setClickedFilterButton(true);
    // Assuming you have some way to get filter values from your UI
    // You can replace these placeholders with actual values from your UI state or input fields
    const filterParams = {
      po_created_date__gte: startDate, // Get values from UI
      po_created_date__lte: endDate,
      category_id: categoryTreeFilter,
      rfq_detail: rfqStatus,
    };

    setState(filterParams);
  };

  const handleDownload = async (id, vendorId) => {
    window.open(
      `/pdfdownload-purchase-order-details/pdf/${id}/${vendorId}`,
      "_blank"
    );
  };

  const columns = [
    {
      title: "RFQ Number",
      dataIndex: "rfq_number",
      key: "rfq_number",
      sorter: true,
      width: 130,
    },
    {
      title: "PO Number",
      dataIndex: "po_number",
      key: "po_number",
      sorter: true,
      width: 120,
    },
    {
      title: "Company Name",
      dataIndex: "company_name",
      key: "company_name",
      sorter: true,
      width: 200,
    },
    {
      title: "PO Created Date",
      dataIndex: "po_created_date",
      key: "po_created_date",
      sorter: true,
      width: 180,
      render: (value, row) => {
        return (
          <div>
            {value !== null
              ? moment(value, "DD-MM-YYYY HH:mm").format("DD-MM-YYYY")
              : "Pending"}
          </div>
        );
      },
    },
    {
      title: "PO Approval Date",
      dataIndex: "po_approval_date",
      key: "po_approval_date",
      sorter: true,
      width: 180,
      render: (value, row) => {
        return (
          <div>
            {value !== null
              ? moment(value, "DD-MM-YYYY HH:mm").format("DD-MM-YYYY")
              : "Pending"}
          </div>
        );
      },
    },
    {
      title: "Amount Without GST",
      dataIndex: "amount_without_gst",
      key: "amount_without_gst",
      align: "right",
      width: 180,
      render: (amount_without_gst) => {
        return (
          <p style={{ textAlign: "end" }}>
            {`\u20B9 ${
              amount_without_gst?.toLocaleString("en-IN", {
                maximumFractionDigits: 0,
              }) || 0
            }`}
          </p>
        );
      },
    },
    {
      title: "Amount With GST",
      dataIndex: "amount_with_gst",
      key: "amount_with_gst",
      align: "right",
      width: 180,
      sorter: true,
      render: (amount_with_gst) => {
        return (
          <p style={{ textAlign: "end" }}>
            {`\u20B9 ${
              amount_with_gst?.toLocaleString("en-IN", {
                maximumFractionDigits: 0,
              }) || 0
            }`}
          </p>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "po_status",
      key: "po_status",
      width: 240,
      sorter: true,
    },
    {
      title: "Vendor Delivery Status",
      dataIndex: "vendor_delivery_status",
      key: "vendor_delivery_status",
      width: 230,
      sorter: true,
    },
    {
      title: "Payment Status",
      dataIndex: "payment_status",
      key: "payment_status",
      width: 200,
      sorter: true,
    },
    {
      title: "Action",
      fixed: "right",
      key: "action",
      width: 80,
      render: (record) => {
        return (
          <Tooltip
            title="View & Download Purchase Order"
            color="#094E8F"
            placement="left"
          >
            <DownloadOutlined
              onClick={() => handleDownload(record.id, record.vendor)}
            />
          </Tooltip>
        );
      },
    },
  ];

  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };
  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);

  const [checkedList, setCheckedList] = useState([
    "action",
    "rfq_number",
    "po_number",
    "company_name",
    "po_created_date",
    "po_approval_date",
    "amount_without_gst",
    "amount_with_gst",
    "po_status",
    "vendor_delivery_status",
    "payment_status",
  ]);

  const handleColumnVisibilityChange = (checkedValues) => {
    setCheckedList(checkedValues);
  };

  const filteredColumns = columns.filter((column) =>
    checkedList.includes(column.key)
  );

  // Column filter dropdown menu
  const columnMenu = (
    <Menu
      className="packagelistdropdown"
      style={{ width: "450px", padding: "10px", borderRadius: "8px" }}
    >
      <Menu.Item key="columnMenu">
        <Checkbox.Group
          value={checkedList}
          onChange={handleColumnVisibilityChange}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <Row style={{ width: "100%" }}>
            <Col span={12}>
              <Checkbox value="action" disabled>
                Action
              </Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="rfq_number">RFQ Number</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="po_number">PO Number</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="company_name">Company Name</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="po_approval_date">PO Created Date</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="amount_without_gst">Amount Without GST</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="amount_with_gst">Amount With GST</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="po_status">Status</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="vendor_delivery_status">
                Vendor Delivery Status
              </Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="payment_status">Payment Status</Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3>{t("po_summary")} </h3>

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("RFQ")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{t("po_summary")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            <div className="searchwrp">
              <Space direction="vertical">
                {/* <Search
                  prefix={
                    <img
                      src={SearchIcon}
                      alt="SearchIcon"
                      className="SearchIcon"
                      width={22}
                    />
                  }
                  placeholder={t("pl_search_list")}
                  onChange={searchCallbackDelayed}
                  style={{
                    width: 250,
                  }}
                /> */}
                <Form form={form}>
                  <Form.Item name="search" initialValue="">
                    <Search
                      prefix={
                        <img
                          src={SearchIcon}
                          alt="SearchIcon"
                          className="SearchIcon"
                          width={22}
                        />
                      }
                      placeholder={t("pl_search_list")}
                      onChange={searchCallbackDelayed}
                      style={{
                        width: 250,
                      }}
                    />
                  </Form.Item>
                </Form>
              </Space>
            </div>
          </Space>
        </div>
      </div>
      <section className="grid-sec tablegridsec">
        <div className="PR-body">
          <section className="Block-Sec-Demo1 mb-5">
            <Row gutter={[15]}>
              {[
                {
                  status: "",
                  title: "Total PO",
                  count: statusCounts.total_purchase_order,
                  icon: TotalCount,
                  blockClass: "block-1",
                },
                {
                  status: "Approve and Issued Order",
                  title: "Order Issued",
                  count: statusCounts.approve_and_issued_order,
                  icon: OrderIssuedApprove,
                  blockClass: "block-1",
                },
                {
                  status: "Pending for Approval",
                  title: "Approval Pending",
                  count: statusCounts.pending_for_approval,
                  icon: PendingActions,
                  blockClass: "block-1",
                },
                {
                  status: "Order Accepted By Vendor",
                  title: "Order Accepted",
                  count: statusCounts.order_accepted_by_vendor,
                  icon: OrderApprove,
                  blockClass: "block-2",
                },
                {
                  status: "Order Rejected By Vendor",
                  title: "Order Rejected",
                  count: statusCounts.order_rejected_by_vendor,
                  icon: rejectedIcon,
                  blockClass: "block-3",
                },
                {
                  status: "Send For Approval",
                  title: "Send For Approval",
                  count: statusCounts.send_for_approval,
                  icon: pendingIcon,
                  blockClass: "block-3",
                },
              ].map((item, index) => (
                <Col key={index}>
                  <div
                    className={`card mb-5 ${
                      selectedCard === item.status ? "active" : ""
                    }`}
                    onClick={() => handleClickCard(item.status)}
                    style={{
                      width: "fit-content",
                    }}
                  >
                    <div className="card-block">
                      <div className="card-box">
                        <div className="card-icon">
                          <img src={item.icon} alt={item.title} width={35} />
                        </div>
                        <div className="card-description">
                          <h3 className="color-blue">{item.title}</h3>
                          <p>{item.count}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </section>
          <div className="filterrow">
            <div className="filtercol">
              <Form autoComplete="off" ref={formRef}>
                <Space wrap>
                  <Col xs={24} className="TextFeild gutter-row">
                    <Form.Item name="po_created_date__gte">
                      <DatePicker
                        format="DD-MM-YY"
                        placeholder="Select start date"
                        value={startDate}
                        onChange={handleStartDateChange}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} className="TextFeild gutter-row">
                    <Form.Item name="po_created_date__lte">
                      <DatePicker
                        format="DD-MM-YY"
                        placeholder="Select end date"
                        value={endDate}
                        onChange={handleEndDateChange}
                      />
                    </Form.Item>
                  </Col>
                  {/* {endDate || startDate || categoryTreeFilter || rfqStatus ? ( */}
                  <>
                    <Button
                      type="primary"
                      icon={
                        <Tooltip title="Apply" color="#094E8F">
                          <FilterOutlined style={{ fontSize: "20px" }} />
                        </Tooltip>
                      }
                      onClick={startDate || endDate ? handleApplyFilter : null}
                      style={{
                        backgroundColor: "#094e8f",
                        color: "#ffffff",
                        border: "none",
                        boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                        width: "40px",
                        height: "40px",
                        borderRadius: "4px",
                      }}
                    />

                    <Button
                      htmlType="Reset"
                      type="primary"
                      icon={
                        <Tooltip title="Reset" color="#094E8F">
                          <UndoOutlined style={{ fontSize: "20px" }} />
                        </Tooltip>
                      }
                      onClick={
                        clickedFilterButton ? handleReset : handleClearFields
                      }
                      style={{
                        backgroundColor: "#094e8f",
                        color: "#ffffff",
                        border: "none",
                        boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                        width: "40px",
                        height: "40px",
                        borderRadius: "4px",
                      }}
                    />
                  </>
                  {/* ) : (
                  ""
                )} */}
                </Space>
              </Form>
            </div>
            <div className="btnscol">
              <Space>
                {/* <ButtonField
                  className="SaveGradiantBtn"
                  type="primary"
                  htmlType="Excel"
                  label="PDF"
                  // onClick={handleExcelDownload}
                  onClick={handlePdfDownload}
                  icon={<img src={ExelDownload} alt="Plus Square" />}
                /> */}
                <ButtonField
                  className="SaveGradiantBtn"
                  type="primary"
                  htmlType="Refresh"
                  label="Refresh"
                  onClick={handleRefresh}
                  icon={<img src={RefreshIcon} alt="Refresh Icon" />}
                />
                <div>
                  <Space
                    style={{
                      backgroundColor: "#094e8f",
                      padding: "4px",
                      borderRadius: "4px",
                    }}
                  >
                    <Dropdown
                      overlay={columnMenu}
                      trigger={["click"]}
                      placement="bottomRight"
                      visible={dropdownVisible}
                      onVisibleChange={setDropdownVisible}
                    >
                      <Tooltip
                        title="Modify Columns"
                        placement="topLeft"
                        color="#094E8F"
                      >
                        <Button
                          type="primary"
                          icon={<ColumnList />}
                          onClick={(e) => e.preventDefault()}
                          style={{
                            backgroundColor: "#094e8f",
                            color: "#ffffff",
                            border: "none",
                            boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                          }}
                        />
                      </Tooltip>
                    </Dropdown>
                  </Space>
                </div>
              </Space>
            </div>
          </div>
          <div className="tablewrp">
          <Table
            columns={filteredColumns}
            rowSelection={rowSelection}
            dataSource={rfqHistory}
            rowKey={(record) => record.id}
            scroll={{
              x: 1000,
            }}
            loading={loading}
            pagination={{
              current: state.page,
              pageSize: state.pagesize,
              defaultCurrent: state.page,
              defaultPageSize: state.pagesize,
              total: totalCount,
              showSizeChanger: true,
              showTotal: (total) => `Total ${total} items`,
            }}
            onChange={handleTableChange}
          />
          </div>
        </div>
      </section>
    </>
  );
};
export default VendorPurchaseOrderSummary;
